import React, { useState, useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import TopDestinationMultiRow from "../../../../../components/multiRow/TopDestinationMultiRow";
import Footer from "../../../../../components/footerPage/Footer";
import AllHeader from "../../../../../components/Navbar/AllHeader";
import YachtCards from "../../../../../components/card/YachtCards";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ImageUnderCard from "../../../../../components/card/ImageUnderCard";
import BoatHelm from "../../../../../Asset/icon/boat_helm.svg";
import TripDetailCard from "../../../../../components/card/TripDetailCard";
import PackagesCard from "../../../../../components/card/PackagesCard";
import BestSeller from "../../../homePages/components/BestSeller";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtInfoAmenitiesDetail } from "../../../../../redux/YachtInfoAmenities/YachtInfoAmenitiesSlice";
import { getYachtInfoWaterToyDetail } from "../../../../../redux/YachtInfoWaterToy/YachtInfoWaterToySlice";
import { getYachtInfoGalleryDetail } from "../../../../../redux/yachtInfoGallery/YachtInfoGallerySlice";
import { getYachtInfoDestinationPackageDetail } from "../../../../../redux/yachtInfoDestinationPackage/YachtInfoDestinationPackageSlice";
import {
  getMarinaDetail,
  getProvinceDetail,
  getDestinationDetail,
} from "../../../../../redux/centerData/CenterDataSlice";
import { getYachtDetail } from "../../../../../redux/yacht/YachtSlice";
import { getUserDetail } from "../../../../../redux/Auth/AuthSlice";
import {
  addToWhitelistAction,
  getWhitelistAction,
  removeFromWhitelistAction,
} from "../../../../../redux/booking/BookingSlice";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import YachtType from "../../../../../components/card/yachtTypeDetail";
import Sail from "../../../../../Asset/image/yacht/Sail.gif";
import SEO from "../../../../../components/SEO/SEO";

function DetailYacht() {
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  const { slug } = useParams();
  const navigate = useNavigate();

  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  const token = useSelector((state) => state.auth?.token);
  const isAuth = useSelector((state) => state.auth?.isAuthenticated);
  const userDetails = useSelector((state) => state.AuthSlice.user);

  const [loading, setLoading] = useState(true);
  const whitelist = todos.Booking.whitelistResults?.data;

  const [searchParams] = useSearchParams();

  const price = searchParams.get("price");
  const originalPrice = searchParams.get("originalPrice");
  const discountType = searchParams.get("discountType");
  const discountValue = searchParams.get("discountValue");
  const promotionCode = searchParams.get("promotionCode");

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      // ✅ เช็คว่าล็อกอินแล้ว มี token ถึงจะดึง user
      if (isAuth && token) {
        await dispatch(getUserDetail({ token }));
      }

      Promise.all([
        dispatch(getDestinationDetail({})),
        dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
        dispatch(getMarinaDetail({})),
        dispatch(getProvinceDetail({})),
        dispatch(getYachtDetail({})),
        dispatch(getWhitelistAction({})),
        dispatch(getYachtInfoAmenitiesDetail({})),
        dispatch(getYachtInfoWaterToyDetail({})),
        dispatch(getYachtInfoGalleryDetail({})),
        dispatch(getYachtInfoDestinationPackageDetail({})),
      ])
        .then(() => {
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };

    fetchData();
  }, [dispatch, isAuth, token]);

  const today = new Date();

  const selectedYacht = loading
    ? [] // ถ้ายังโหลดข้อมูลอยู่ คืนค่าเป็น array ว่าง
    : (
      todos.YachtInfoSellingPriceRatePlanListSlice
        .YachtInfoSellingPriceRatePlanList?.results || []
    ).filter((yacht) => {
      // ✅ กรองเฉพาะเรือที่ id_yachtInfo ตรงกับ slug
      const isMatchingSlug = yacht.id_sellingPrice === slug;

      // ✅ แปลงวันที่จาก "2025/10/16" → "2025-10-16"
      const startDate = yacht.start_rate_plan_date
        ? new Date(yacht.start_rate_plan_date.replace(/\//g, "-"))
        : null;
      const endDate = yacht.end_rate_plan_date
        ? new Date(yacht.end_rate_plan_date.replace(/\//g, "-"))
        : null;

      // ✅ ตรวจสอบว่าอยู่ในช่วงวันที่เปิดให้ขายหรือไม่
      const isWithinDateRange =
        (!startDate || today >= startDate) && (!endDate || today <= endDate);

      // ✅ คืนค่าเฉพาะเรือที่ทั้ง id ตรงกับ slug และอยู่ในช่วงวันที่แสดงได้
      return isMatchingSlug && isWithinDateRange;
    });

  const selectedYachtWithMarinaAndProvince = loading
    ? [] // ถ้า loading อยู่ ให้คืนค่าเป็น array ว่าง
    : selectedYacht.map((yacht) => {
      // ดึงข้อมูล Marina ที่เกี่ยวข้องกับเรือลำนี้
      const marina = todos.CenterDataSlice.Marina?.results.find(
        (marina) => marina.id_marina === yacht.id_marina,
      );

      // ดึงข้อมูล Province ของ Marina นั้น
      const province = todos.CenterDataSlice.Province?.results.find(
        (province) => province.ProvinceID === marina?.id_province,
      );

      // ดึงข้อมูล Travel Agent ที่ดูแลเรือลำนี้
      const travelAgent = todos.YachtSlice.Yacht?.results.find(
        (y) => y.id_yacht === yacht.id_yacht,
      );

      const travelAgentNo = todos.YachtSlice.Yacht?.results.find(
        (y) => y.id_yacht === yacht.id_yacht,
      );

      const vat = todos.YachtSlice.Yacht?.results.find(
        (y) => y.id_yacht === yacht.id_yacht,
      );

      // ดึงข้อมูล Amenities (สิ่งอำนวยความสะดวก) ของเรือ
      const YachtInfoAmenities =
        todos.YachtInfoAmenitiesSlice.YachtInfoAmenities?.results.filter(
          (yachtInfoAmenities) =>
            yachtInfoAmenities.id_yachtInfo === yacht.id_yachtInfo,
        );

      // ดึงข้อมูล Water Toy (อุปกรณ์เล่นน้ำ) ของเรือ
      const YachtInfoWaterToy =
        todos.YachtInfoWaterToySlice.YachtInfoWaterToy?.results.filter(
          (yachtInfoWaterToy) =>
            yachtInfoWaterToy.id_yachtInfo === yacht.id_yachtInfo,
        );

      // ดึงข้อมูล Gallery (รูปภาพ) ของเรือ
      const YachtInfoGallery =
        todos.YachtInfoGallerySlice.YachtInfoGallery?.results.filter(
          (yachtInfoGallery) =>
            yachtInfoGallery.id_yachtInfo === yacht.id_yachtInfo,
        );

      // ดึงข้อมูลแพ็กเกจท่องเที่ยวที่เกี่ยวข้องกับเรือลำนี้
      const YachtInfoDestinationPackage =
        todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage?.results.find(
          (yachtInfoDestinationPackage) =>
            yachtInfoDestinationPackage.id_destination_package ===
            yacht.id_destination_package,
        );

      // แปลง destination_included ให้เป็น array ของ ID
      const destinationIds =
        YachtInfoDestinationPackage?.destination_included?.split(",") || [];

      // ดึงชื่อสถานที่ท่องเที่ยว (ภาษาอังกฤษ)
      const destinationNamesEn = destinationIds.map((destinationId) => {
        const destination = todos.CenterDataSlice.Destination.results.find(
          (destination) => destination.id_destination === destinationId,
        );
        return destination ? destination.name_destination_en : null;
      });

      // ดึงชื่อสถานที่ท่องเที่ยว (ภาษาไทย)
      const destinationNamesTh = destinationIds.map((destinationId) => {
        const destination = todos.CenterDataSlice.Destination.results.find(
          (destination) => destination.id_destination === destinationId,
        );
        return destination ? destination.name_destination_th : null;
      });

      const yachtInfo =
        todos.YachtInformationSlice.YachtInformation?.results.find(
          (info) => Number(info.id_yachtInfo) === Number(yacht.id_yachtInfo),
        );

      // รวมชื่อสถานที่ท่องเที่ยวเป็น String คั่นด้วย ,
      const formattedDestinationListEn = destinationNamesEn.join(",");
      const formattedDestinationListTh = destinationNamesTh.join(",");

      return {
        ...yacht,
        name_marina_en: marina ? marina.name_marina_en : null,
        name_marina_th: marina ? marina.name_marina_th : null,
        ProvinceEng: province ? province.ProvinceEng : null,
        ProvinceThai: province ? province.ProvinceThai : null,
        ProvinceID: province ? province.ProvinceID : null,
        travelAgent: travelAgent ? travelAgent.name_yacht : null,
        travelAgentNo: travelAgentNo ? travelAgentNo.travel_agent_no : null,
        vat: vat ? vat.vat : null,
        YachtInfoAmenities: YachtInfoAmenities || [], // ถ้าไม่มีข้อมูล ให้คืนค่าเป็น array ว่าง
        YachtInfoWaterToy: YachtInfoWaterToy || [],
        YachtInfoGallery: YachtInfoGallery || [],
        YachtInfoDestinationPackage: YachtInfoDestinationPackage || null, // ถ้าไม่มีข้อมูล ให้คืนค่าเป็น null
        formattedDestinationListEn: formattedDestinationListEn || null,
        formattedDestinationListTh: formattedDestinationListTh || null,
        description_yacht_yachtInfo:
          yachtInfo?.description_yacht_yachtInfo || null,
      };
    });

  const toggleWhitelist = (yachtId) => {
    if (!userDetails.idUserTMY) {
      navigate("/Home");
      return;
    }

    const payload = {
      id_sellingPrice: Number(yachtId),
      idUserTMY: Number(userDetails.idUserTMY),
    };

    const alreadyWhitelisted = whitelist.some(
      (item) =>
        item.id_sellingPrice === Number(yachtId) &&
        item.idUserTMY === Number(userDetails.idUserTMY),
    );

    if (alreadyWhitelisted) {
      dispatch(removeFromWhitelistAction(payload))
        .then(() => {
          dispatch(getWhitelistAction());
        })
        .catch((error) => {
          console.error("Error removing from whitelist:", error);
        });
    } else {
      dispatch(
        addToWhitelistAction({
          yachtId,
          idUserTMY: userDetails.idUserTMY,
        }),
      )
        .then(() => {
          dispatch(getWhitelistAction());
        })
        .catch((error) => {
          console.error("Error adding to whitelist:", error);
        });
    }
  };

  const yachtselect = selectedYachtWithMarinaAndProvince[0];

  const seoDescription =
    yachtselect?.description_yacht_yachtInfo?.trim()?.slice(0, 160) ||
    (selectedLanguage === "en"
      ? `Private yacht charter ${yachtselect?.name_yacht_yachtInfo} in ${yachtselect?.ProvinceEng}, fully crewed and accommodating up to ${yachtselect?.guests_day} guests.`
      : `เช่าเรือยอชต์ ${yachtselect?.name_yacht_yachtInfo} ที่${yachtselect?.ProvinceThai} เหมาลำพร้อมลูกเรือ รองรับ ${yachtselect?.guests_day} คน`);

  const isEN = selectedLanguage === "en";

  const yachtselects = selectedYachtWithMarinaAndProvince?.[0];

  const yachtName = yachtselects?.name_yacht_yachtInfo || "";
  const provinceName = isEN
    ? yachtselects?.ProvinceEng || ""
    : yachtselects?.ProvinceThai || "";

  const formatDateToISO = (dateStr) => {
    if (!dateStr) return null;

    const date = new Date(dateStr.replace(/\//g, "-"));
    return date.toISOString().split("T")[0];
  };

  return (
    <>
      {!loading && selectedYachtWithMarinaAndProvince[0] && (
        <SEO
          title={
            isEN
              ? `${yachtName} - Yacht Charter in ${provinceName} | Take My Yacht`
              : `${yachtName} - เช่าเรือยอชต์ที่ ${provinceName} | Take My Yacht`
          }
          description={seoDescription}
          url={`https://takemyyacht.com/yacht/detailYacht/${slug}`}
          schema={{
            "@context": "https://schema.org",
            "@type": "Product",
            name: yachtName,
            image: selectedYachtWithMarinaAndProvince[0].logo_yachtInfo_url,
            description: seoDescription,
            brand: {
              "@type": "Brand",
              name: "Take My Yacht",
            },
            offers: {
              "@type": "Offer",
              priceCurrency: "THB",
              price:
                price &&
                  originalPrice &&
                  Number(price) !== Number(originalPrice)
                  ? Number(price)
                  : selectedYachtWithMarinaAndProvince[0].value_sellingPrice,
              priceValidUntil: formatDateToISO(
                selectedYachtWithMarinaAndProvince[0]?.end_rate_plan_date
              ) || undefined,
              availability: "https://schema.org/InStock",
              url: `https://takemyyacht.com/yacht/${slug}`,
            },
          }}
        />
      )}

      <div>
        <AllHeader />
        <div className="container mt-5vh">
          <div className="row align-items-stretch">
            <div className="col-lg-1 order-md-1 d-none d-lg-block"></div>
            <div className="col-lg-4 text-center order-md-2 col-md-12 mb-4">
              <TopDestinationMultiRow />
            </div>
            <div className="col-lg-1 order-md-2 d-none d-lg-block"></div>
            <div className="col-lg-5 text-center order-md-2 col-md-12 mb-4">
              <div className="mb-4">
                <img
                  className="BoatHelm-1"
                  draggable={false}
                  src={BoatHelm}
                  alt="BoatHelm"
                />
                <h2>{t("Yacht lists")}</h2>
              </div>

              <div className="mb-4">
                {!loading ? (
                  <div>
                    {selectedYachtWithMarinaAndProvince[0] ? (
                      <div>
                        <YachtCards
                          id={
                            selectedYachtWithMarinaAndProvince[0]
                              .id_sellingPrice
                          }
                          headline={
                            selectedYachtWithMarinaAndProvince[0]
                              .name_yacht_yachtInfo
                          }
                          image={
                            selectedYachtWithMarinaAndProvince[0]
                              .logo_yachtInfo_url
                          }
                          marina={
                            selectedLanguage === "en"
                              ? selectedYachtWithMarinaAndProvince[0]
                                .name_marina_en
                              : selectedYachtWithMarinaAndProvince[0]
                                .name_marina_th
                          }
                          province={
                            selectedLanguage === "en"
                              ? selectedYachtWithMarinaAndProvince[0]
                                .ProvinceEng
                              : selectedYachtWithMarinaAndProvince[0]
                                .ProvinceThai
                          }
                          travelAgent={
                            selectedYachtWithMarinaAndProvince[0].travelAgent
                          }
                          travelAgentNo={
                            selectedYachtWithMarinaAndProvince[0].travelAgentNo
                          }
                          vat={selectedYachtWithMarinaAndProvince[0].vat}
                          dayOption={
                            selectedYachtWithMarinaAndProvince[0].rate_type
                          }
                          price={
                            price &&
                              originalPrice &&
                              Number(price) !== Number(originalPrice)
                              ? Number(price) // ราคาแบบลดแล้ว
                              : selectedYachtWithMarinaAndProvince[0]
                                .value_sellingPrice // ราคาปกติ
                          }
                          amenities={
                            selectedYachtWithMarinaAndProvince[0]
                              .YachtInfoAmenities
                          }
                          waterToy={
                            selectedYachtWithMarinaAndProvince[0]
                              .YachtInfoWaterToy
                          }
                          cruising_speed={
                            selectedYachtWithMarinaAndProvince[0].cruising_speed
                          }
                          guests_day={
                            selectedYachtWithMarinaAndProvince[0].guests_day
                          }
                          guests_sleeping={
                            selectedYachtWithMarinaAndProvince[0]
                              .guests_sleeping
                          }
                          onWhitelist={() =>
                            toggleWhitelist(
                              selectedYachtWithMarinaAndProvince[0]
                                .id_sellingPrice,
                            )
                          }
                        />

                        <ImageUnderCard
                          Image={selectedYachtWithMarinaAndProvince[0].YachtInfoGallery.map(
                            (YachtInfoGallery) =>
                              YachtInfoGallery.photoUrl_yachtInfoGallery,
                          )}
                        />
                      </div>
                    ) : (
                      <div>{t("No yachts available")}</div>
                    )}
                  </div>
                ) : null}

                <div className="column">
                  <div className="col-12 col-lg-4 mb-4 d-flex align-items-start justify-content-center">
                    <div className="filter-container">
                      <YachtType
                        value_yachtTypes={
                          selectedYachtWithMarinaAndProvince[0]
                            ?.value_yachtTypes || ""
                        }
                        refit_year={
                          selectedYachtWithMarinaAndProvince[0]?.refit_year ||
                          ""
                        }
                        crew={selectedYachtWithMarinaAndProvince[0]?.crew || ""}
                        max_speed={
                          selectedYachtWithMarinaAndProvince[0]?.max_speed || ""
                        }
                        year={selectedYachtWithMarinaAndProvince[0]?.year || ""}
                      />
                    </div>
                  </div>
                  {/* ซ้าย */}

                  <div className="col-12 col-lg-8 mb-4">
                    {selectedYachtWithMarinaAndProvince[0] && (
                      <>
                        <TripDetailCard
                          tripDetail={
                            selectedLanguage === "en"
                              ? selectedYachtWithMarinaAndProvince[0]
                                ?.trip_inclusions_en
                              : selectedYachtWithMarinaAndProvince[0]
                                ?.trip_inclusions_th
                          }
                          title="Trip Inclusions"
                        />

                        <TripDetailCard
                          tripDetail={
                            selectedLanguage === "en"
                              ? selectedYachtWithMarinaAndProvince[0]
                                ?.trip_excluded_en
                              : selectedYachtWithMarinaAndProvince[0]
                                ?.trip_excluded_th
                          }
                          title="Trip Excluded"
                        />
                      </>
                    )}
                  </div>
                  {/* ขวา */}
                </div>

                <div>
                  <img
                    className="BoatHelm-1"
                    draggable={false}
                    src={BoatHelm}
                    alt="BoatHelm"
                  />
                  <h2>{t("Destination Packages")}</h2>
                  {loading ? null : (
                    <div
                      className="col-lg-12 text-center order-md-5 col-md-12 mb-4 mr-auto"
                    >
                      <ul className="p-0">
                        {selectedYachtWithMarinaAndProvince.map(
                          (item, index) => (
                            <PackagesCard
                              name={
                                item.YachtInfoDestinationPackage
                                  .name_destination_package
                              }
                              islands={
                                selectedLanguage === "en"
                                  ? item.formattedDestinationListEn
                                  : item.formattedDestinationListTh
                              }
                              price={
                                price &&
                                  originalPrice &&
                                  Number(price) !== Number(originalPrice)
                                  ? Number(price) // ราคาแบบลดแล้ว
                                  : item.value_sellingPrice // ราคาปกติ
                              }
                              originalPrice={originalPrice}
                              discountType={discountType}
                              discountValue={discountValue}
                              promotionCode={promotionCode}
                              vat={item.vat}
                              dayOption={item.rate_type}
                              slug={item.id_sellingPrice}
                            />
                          ),
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-1 order-md-3 d-none d-lg-block"></div>
            <div className="col-lg-12 text-center order-md-3 col-md-12 mb-4">
              <BestSeller />
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {loading && (
        <div
          className="modal-overlay2"
        >
          <img
            src={Sail}
            alt="Loading..."
            className="modal-image"
            draggable={false}
          />
        </div>
      )}

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="scroll-to-top-btn"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default DetailYacht;
